import React from 'react';
import styles from 'styles/components/QuestionListHeader.module.css';

export interface QuestionListHeaderData {
  title: string;
  subtitle?: string;
  notes?: string[];
  helperText?: string;
  rightElement?: JSX.Element;
}

export const QuestionListHeader: React.FC<QuestionListHeaderData> = props => {
  return (
    <div className={styles.questionListHeaderContainer}>
      <div className={styles.infoContainer}>
        <span className={styles.title}>{props.title}</span>
        {props.subtitle && (
          <span className={styles.sibtitle}>{props.subtitle}</span>
        )}
        {props.notes && (
          <ul className={styles.list}>
            {props.notes.map((note, index) => (
              <li className={styles.note} key={index}>
                {note}
              </li>
            ))}
          </ul>
        )}
        {props.helperText && (
          <span className={styles.helper}>{props.helperText}</span>
        )}
      </div>
      <div className={styles.rightContainer}>{props.rightElement}</div>
    </div>
  );
};
